let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("gL6IV")).then(() => parcelRequire('5jeMe'));